import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { Helmet } from 'react-helmet';
import styled from '@emotion/styled';
import Card from 'components/Card';
import { 
  ButtonGroup, Button
} from "@blueprintjs/core";
import ServiceTypeCategoryTable, {
  SERVICE_TYPE_CATEGORY_COLUMNS, SERVICE_TYPE_CATEGORY_CARDS, SERVICE_TYPE_CATEGORY_MIN_TABLE_WIDTH
} from 'components/Tables/ServiceTypeCategory';
import * as DataList from 'components/DataList';
import BookingsSidebar from '../bookings/bookings-sidebar';
import ServiceTypeCategory from 'components/ServiceTypeCategory/ServiceTypeCategory';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'serviceTypeCategoryStore',) @observer
class ServiceTypeCategoryIndexPage extends Component {

  @observable isServiceTypeCategoryDialogVisible = false;

  componentDidMount() {
    let { serviceTypeCategoryStore } = this.props;
    serviceTypeCategoryStore.loadServiceTypeCategories()
  }

  get canRender() {
    let {
      serviceTypeCategoryStore: {
        serviceTypeCategories: {
          isLoading,
          isError,
          objects
        }
      }
    } = this.props;
    return (!isLoading && !isError && objects);
  }

  onCloseCategoryDialog() {
    this.isServiceTypeCategoryDialogVisible = false;
  }

  onSucessCreateCategory(productService) {
    this.isServiceTypeCategoryDialogVisible = false;
  }

  openAddDialog() {
    this.isServiceTypeCategoryDialogVisible = true;
  }

  // The store doesn't clear isError on a successful load, so clear it here.
  retryLoad() {
    const { serviceTypeCategoryStore } = this.props;
    serviceTypeCategoryStore.serviceTypeCategories.isError = false;
    serviceTypeCategoryStore.loadServiceTypeCategories();
  }

  render() {
    let content;
    let {
      serviceTypeCategoryStore: {
        serviceTypeCategories: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={SERVICE_TYPE_CATEGORY_COLUMNS}
          cards={SERVICE_TYPE_CATEGORY_CARDS}
          minTableWidth={SERVICE_TYPE_CATEGORY_MIN_TABLE_WIDTH}
          noun="service type categories"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="service type categories" onRetry={this.retryLoad.bind(this)} />;
    }
    if (this.canRender) {
      content = <ServiceTypeCategoryTable onAdd={this.openAddDialog.bind(this)} />;
    }
    return(
      <div className="taxed-page-layout">
        <Helmet>
          <title>Service Type Category | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
            <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Card>
                <div>            
                  <div className="text-right mb-2">
                    <ButtonGroup>
                      <Button icon='add' onClick={this.openAddDialog.bind(this)}>
                        Add
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
        <ServiceTypeCategory 
          isOpen={this.isServiceTypeCategoryDialogVisible} 
          title={"Add Service Type Category"}
          edit={false}
          onClose={this.onCloseCategoryDialog.bind(this)}
          onSuccess={this.onSucessCreateCategory.bind(this)}
        />
      </div>
    )
  }

}

export default ServiceTypeCategoryIndexPage;